<template>
	<EMCoreTemplate category="OSMGI" identity="generalPolicy" entity="osm_general_policy"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementGI/containers/GeneralPolicy.vue